import * as React from "react";
import { useCallback, useState } from "react";
import { Modal, List, ListItem, Button, Form } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";

import { useDispatch } from "@teamprevent/admin-redux";

import { deleteReferralFormDocument } from "../../referralActions";

interface DeleteReferralFormDocumentModalProps{
    customerId: string;
    ohCaseId: string;
    documentId: string;
}

export function DeleteReferralFormDocumentModal(props: DeleteReferralFormDocumentModalProps)
{
    const dispatch = useDispatch();

    const { customerId, ohCaseId, documentId } = props;
    const [open, setIsOpen] = useState<boolean>(false);
    const [reason, setReason] = useState<string>("");

    const onOpenModal = () => setIsOpen(true);
    const onCloseModal = () => setIsOpen(false);
    const removeForm = useCallback(async () => {
        dispatch(deleteReferralFormDocument(customerId, ohCaseId, documentId, reason));
        setIsOpen(false);
    }, [customerId, dispatch, documentId, ohCaseId, reason]);

    return (
        <>
            <Modal size="small" open={open} closeOnDimmerClick={false}>
                <Modal.Header>Remove Referral Form Document</Modal.Header>
                <Modal.Content>
                    <div>
                        You are about to remove a document from the case.
                        In doing so, the form will no longer be part of this case and will be no longer visible to the employee or manager.
                        Do you wish to Continue?
                    </div>
                    <Form>
                        <Input.Textarea
                            label={"Reason"}
                            value={reason}
                            onChange={setReason}
                        />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <List horizontal>
                        <ListItem>
                            <Button onClick={onCloseModal} content="No" />
                            <Button onClick={removeForm} content="Yes" />
                        </ListItem>
                    </List>

                </Modal.Actions>
            </Modal>
            <Button className="warning remove-form-document-button" content="Remove Document" onClick={onOpenModal} />
        </>
    );
}
